module.exports = __webpack_public_path__ + "img/14.c9d64a0.png";